import { useState } from 'react';
import { Button, SearchableSelect } from '@eo/shared';

import { HoursStepper } from './HoursStepper';
import type { PlanAddRowProps } from './types';

// Laid out as one more holder of the plan, so adding someone reads like the
// rows above it.
export function PlanAddRow({ clientName, people, onAdd }: PlanAddRowProps) {
  const [userId, setUserId] = useState('');
  const [name, setName] = useState('');
  const [fixedHours, setFixedHours] = useState(0);
  const [variableHours, setVariableHours] = useState(0);
  const [saving, setSaving] = useState(false);

  const add = async () => {
    setSaving(true);
    try {
      await onAdd({ userId, fixedHours, variableHours });
      setUserId('');
      setName('');
      setFixedHours(0);
      setVariableHours(0);
    } catch {
      // The failure was already announced; the row keeps its figures to retry.
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <SearchableSelect
        value={userId}
        selectedLabel={name || undefined}
        ariaLabel="Person"
        placeholder="Add someone…"
        emptyLabel="No one matches"
        options={people.options}
        loading={people.loading}
        hasMore={people.hasMore}
        onSearch={people.onSearch}
        onLoadMore={people.onLoadMore}
        onChange={(value) => {
          setUserId(value);
          setName(people.options.find((o) => o.value === value)?.label ?? '');
        }}
      />
      <HoursStepper
        label="New person fixed hours"
        value={fixedHours}
        min={0}
        onCommit={setFixedHours}
      />
      <HoursStepper
        label="New person variable hours"
        value={variableHours}
        min={0}
        onCommit={setVariableHours}
      />
      <Button
        type="button"
        size="sm"
        variant="secondary"
        aria-label={`Add to ${clientName}`}
        disabled={userId === '' || saving}
        onClick={() => void add()}
      >
        Add
      </Button>
    </>
  );
}
